import {
  gql,
  OperationVariables,
  QueryHookOptions,
  useQuery,
} from '@apollo/client';

import {
  IQueryEscalationConfigurations,
  ServiceNowEscalationConfiguration,
} from './types';

export const QUERY_ESCALATION_CONFIGURATIONS = gql`
  query queryEscalationConfigurations(
    $filter: EscalationConfigurationFilterInput
    $offset: Int
    $size: Int
    $sort: [SortingParameterInput]
  ) {
    queryEscalationConfigurations(
      filter: $filter
      offset: $offset
      size: $size
      sort: $sort
    ) {
      escalation_configurations {
        enabled
        escalation_configuration_id
        service_name
        ... on ServiceNowEscalationConfiguration {
          username
          password
          enabled
          escalation_configuration_id
          instance_name
          service_name
          table_name
        }
      }
      filter {
        enabled
        escalation_configuration_ids
        service_names
      }
      offset
      size
      sort {
        sort_by
        sort_dir
      }
      total_items
    }
  }
`;

export const useQueryEscalationConfigurations = (
  options: QueryHookOptions<
    IQueryEscalationConfigurations<ServiceNowEscalationConfiguration>,
    OperationVariables
  >,
) => {
  return useQuery<
    IQueryEscalationConfigurations<ServiceNowEscalationConfiguration>
  >(QUERY_ESCALATION_CONFIGURATIONS, options);
};
